import { render, staticRenderFns } from "./ListFooterV2.vue?vue&type=template&id=0d1727a8&scoped=true&"
import script from "./ListFooterV2.vue?vue&type=script&lang=js&"
export * from "./ListFooterV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1727a8",
  null
  
)

export default component.exports